// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"1662e91bc6e1cd1b6bbc","303":"d2a59e579f089b292be3","495":"5f17fb57f24ca5b67920"}[chunkId] + ".js";
};